import { render, staticRenderFns } from "./contract_detail.vue?vue&type=template&id=5aa17580&scoped=true&"
import script from "./contract_detail.vue?vue&type=script&lang=js&"
export * from "./contract_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa17580",
  null
  
)

export default component.exports